import { Button } from '@material-ui/core';
import NavigationBottom from 'component/navigation/navigation_bottom_home';
import { useEffect, useState } from 'react';
import { use100vh } from 'react-div-100vh';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { PATH } from 'routes/constant';
import icon404 from '../../assets/svg/404_error.svg';
import { ReactComponent as Icon500 } from '../../assets/svg/500_error.svg';
import NavigationBottomStylist from '../../component/navigation/navigation_bottom_stylist';
import { StandardAlert } from '../../component/StandardAlert';
import UserType from '../../constants/user';
import { RootState } from '../../redux/store';
import { useStyles } from './styles';

const ErrorPage = ({ type }) => {
    const classes = useStyles();
    const height: any = use100vh();
    const history = useHistory();

    const goBack = () => {
        history.goBack();
    };

    const [heightContent, setHeightContent] = useState<any>();
    const user = useSelector((state: RootState) => state.userDetail?.me);
    useEffect(() => {
        if (height) {
            setHeightContent(height - 112 - 20);
        }
    }, [height]);

    return (
        <div className={classes.wrapper}>
            <div
                id="main"
                className={classes.main}
                style={{
                    minHeight: `${height}px`,
                }}
            >
                {/* <div className={classes.header}>
                    <span
                        style={{
                            fontSize: 24,
                            fontWeight: 400,
                            margin: 0,
                            fontFamily: 'Fraunces_120pt_SuperSoft_Wonky-Regular',
                            color: '#fff',
                            flex: 1,
                        }}
                    >
                        Taffi
                    </span>
                </div> */}

                <div
                    className={classes.contentPage}
                    style={{
                        maxHeight: `${heightContent}px`,
                    }}
                >
                    {type === 500 && (
                        <>
                            <StandardAlert
                                height={`calc( ${heightContent}px - 100px)`}
                                SvgIcon={Icon500}
                                title={'Error 500'}
                                body={'Server error. Our connection to the server has failed.'}
                                onButtonClick={() => {}}
                                widthIcon={'210px'}
                                heightIcon={'150px'}
                            />
                            <div
                                style={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                }}
                            >
                                <Button className={classes.errorButton} onClick={goBack}>
                                    Go back
                                </Button>
                            </div>
                        </>
                    )}
                    {type === 404 && (
                        <>
                            <StandardAlert
                                height={`calc( ${heightContent}px - 100px)`}
                                icon={icon404}
                                title={'Error 404'}
                                body={'Page not found or content no longer exists.'}
                                onButtonClick={() => {}}
                                widthIcon={'210px'}
                                heightIcon={'210px'}
                            />
                            <div
                                style={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                }}
                            >
                                <Button onClick={() => history.push(PATH.HOME)} className={classes.errorButton}>
                                    <span>Go home</span>
                                </Button>
                            </div>
                        </>
                    )}
                </div>
            </div>

            {user?.userType ? (
                user?.userType === UserType.Customer ? (
                    <NavigationBottom />
                ) : (
                    <NavigationBottomStylist isDisable={!user.approved} />
                )
            ) : (
                <NavigationBottom />
            )}
        </div>
    );
};

export default ErrorPage;
